import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { memberPrescriptionRefillsWidget as MemberPrescriptionRefillsWidgetView } from 'ui/views/widgets/memberPrescriptionRefillsWidget';
import { MemberPrescriptionRefillsWidgetService } from 'services/memberPrescriptionRefillsWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import searchQuery from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberPrescriptionRefillsWidget } from 'ui/containers/MemberPrescriptionRefillsWidget';
 *
 * // render
 * <MemberPrescriptionRefillsWidget propName='propValue'/>
 */
class _MemberPrescriptionRefillsWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        this.handleActionClick = this.handleActionClick.bind( this );

        // member prescriptions instance
        this.memberPrescriptionRefillsWidgetService = new MemberPrescriptionRefillsWidgetService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    async fetchComponentData() {
        log.debug( 'MemberPrescriptionDetailSummary.fetchComponentData()' );
        
         // cancel ongoing request
         this.memberPrescriptionRefillsWidgetService.cancel();

        try {
            const { status, data }  = await this.memberPrescriptionRefillsWidgetService.fetchComponentData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'MemberPrescriptionClaimsWidget.handleActionClick()' );

        const memberId = get( this.props.location, 'state.memberId', undefined );

        if( 'column' === type && 'orderNumber' === value.name  ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                search: searchQuery.stringify( {
                    orderId: item.id,
                } ),
                state: { memberId: memberId }
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberPrescriptionRefillsWidgetService.cancel(); // cancel ongoing requests
    }


    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberPrescriptionRefillsWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberPrescriptionRefillsWidget.displayName = 'MemberPrescriptionRefillsWidget';

// set default props
_MemberPrescriptionRefillsWidget.defaultProps = {};

// prop types
_MemberPrescriptionRefillsWidget.propTypes = {};

export const MemberPrescriptionRefillsWidget = withRouter( _MemberPrescriptionRefillsWidget );
